import React, {useState} from "react"
import {Link} from "react-router-dom"
import {Button, Menu, MenuItem} from "@mui/material"

function NewButton() {
	const [anchorEl, setAnchorEl] = useState()

	const handleClick = (e) => {
		setAnchorEl(e.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<>
			<Button onClick={handleClick}>New</Button>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				anchorOrigin={{vertical: "bottom", horizontal: "right"}}
				transformOrigin={{vertical: "top", horizontal: "right"}}
				onClose={handleClose}
			>
				<li>
					<MenuItem component={Link} to="/email-templates/new" onClick={handleClose}>
						Email Template
					</MenuItem>
				</li>
				<li>
					<MenuItem component={Link} to="/sms-templates/new" onClick={handleClose}>
						SMS Template
					</MenuItem>
				</li>
			</Menu>
		</>
	)
}

export {NewButton}
